import React from 'react';
import LaunchDarkly from '@saucelabs/sl-util-launchdarkly';

import ApplicationContent from './ApplicationContent';

const ApplicationContentWithLaunchdarkly = (props) => (
  <LaunchDarkly>
    <ApplicationContent {...props} />
  </LaunchDarkly>
);

export default ApplicationContentWithLaunchdarkly;
export { ApplicationContentWithLaunchdarkly };
